import { makeStyles } from 'tss-react/mui';

export const useCellStyles = makeStyles({ name: 'Cell' })(theme => ({
  name: {
    color: theme.palette.text.primary,
    letterSpacing: '0.4px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  nameLink: {
    color: '#A63287',
    textDecoration: 'underline',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  email: {
    letterSpacing: '0.4px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
}));
